import { __rest, __assign } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { StyledButton, I } from './styles.js';

var defaultValueVariation = 'primary';
var Button = function (_a) {
    var children = _a.children, _b = _a.variation, variation = _b === void 0 ? defaultValueVariation : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, disabled = _a.disabled, IconRight = _a.iconRight, IconLeft = _a.iconLeft, onClick = _a.onClick, fixed = _a.fixed, props = __rest(_a, ["children", "variation", "size", "disabled", "iconRight", "iconLeft", "onClick", "fixed"]);
    return (React.createElement(StyledButton, __assign({ variation: variation, size: size, disabled: disabled, onClick: disabled ? undefined : onClick, fixed: fixed }, props),
        IconLeft && (React.createElement(I, { iconLeft: IconLeft, size: size }, React.createElement(IconLeft, { viewBox: "0 0 24 24" }))),
        children,
        IconRight && React.createElement(I, { size: size }, React.createElement(IconRight, { viewBox: "0 0 24 24" }))));
};

export { Button as default, defaultValueVariation };
